'use client';
import type { Asset } from 'types/generated/contentful';
import { gray900 } from '@mentimeter/ragnar-colors';
import { format } from 'date-fns/format';
import { getContentfulAssetImageProps } from 'src/cms/utils/utils';
import NextImage from 'src/components/image/NextImage';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { Meta } from '@mentimeter/ragnar-ui/typography';
import { H3 } from '../typography';
import { Clickable } from '../actions';

export interface ThumbnailPostT {
  slug: string;
  editorName: string;
  title: string;
  featuredImage: Asset;
  category: {
    slug: string;
    title: string;
  };
  introduction: string;
  time: string;
  date: string;
}
export interface ThumbnailT {
  post: ThumbnailPostT;
}

export function Thumbnail({
  post: { slug, date, category, title, featuredImage },
}: ThumbnailT) {
  const formattedDate = format(new Date(date), 'MMMM dd, yyyy');

  return (
    <Clickable
      href={`/blog/${category.slug || ''}/${slug}`}
      key={slug}
      aria-label="Go to blog post"
      width="100%"
      extend={() => ({
        transition: 'transform 0.3s ease',
        '@media (hover: hover)': {
          ':hover': {
            opacity: 1,
            transform: 'translateY(-8px)',
            '& h3': {
              textDecoration: 'underline',
            },
          },
        },
      })}
      flexDirection="column"
    >
      {featuredImage.fields?.file && (
        <Box
          mb="space4"
          overflow="hidden"
          extend={() => ({
            borderBottomRightRadius: '60px',
          })}
        >
          <NextImage
            alt={title}
            {...getContentfulAssetImageProps(featuredImage)}
            style={{ height: '220px', objectFit: 'cover' }}
          />
        </Box>
      )}
      <Box flexDirection="row" mb={['space2', 'space3']}>
        <Text color="brand" mr="space3">
          {category.title}
        </Text>
        <Meta fontSize="100" color={gray900}>
          {formattedDate}
        </Meta>
      </Box>
      <H3 color="black" lineHeight="200" fontWeight="regular" mb="space0">
        {title}
      </H3>
    </Clickable>
  );
}
